import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = {
  key: 0,
  class: "sidebar"
}
const _hoisted_2 = { class: "sidebar-content" }
const _hoisted_3 = { class: "dashboard-container button-container" }
const _hoisted_4 = {
  key: 0,
  class: "performance-container button-container"
}
const _hoisted_5 = { class: "settings-container button-container" }
const _hoisted_6 = {
  key: 1,
  class: "app-header"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "yb-logo",
  src: _imports_0,
  alt: "Logo"
}, null, -1)
const _hoisted_8 = { class: "headerIcons" }
const _hoisted_9 = {
  key: 2,
  class: "app-panel"
}
const _hoisted_10 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardButton = _resolveComponent("DashboardButton")!
  const _component_PerformanceButton = _resolveComponent("PerformanceButton")!
  const _component_SettingsButton = _resolveComponent("SettingsButton")!
  const _component_HomeButton = _resolveComponent("HomeButton")!
  const _component_ProfileButton = _resolveComponent("ProfileButton")!
  const _component_LogoutButton = _resolveComponent("LogoutButton")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_login_view = _resolveComponent("login-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.path.includes('/client/') && _ctx.$route.path !== '/client/0')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_DashboardButton, {
                onButtonClick: _ctx.gotoClientDashboard,
                selected: _ctx.$route.path.includes(_ctx.extractClientId() + '/dashboard')
              }, null, 8, ["onButtonClick", "selected"])
            ]),
            (_ctx.extractProjectId())
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_PerformanceButton, {
                    onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoResults())),
                    selected: _ctx.$route.path.includes('/results-dashboard')
                  }, null, 8, ["selected"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SettingsButton, {
                onButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoSetting())),
                selected: _ctx.$route.path == '/client/' + _ctx.extractClientId()
              }, null, 8, ["selected"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.token != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_HomeButton, {
              click: _ctx.onHome,
              selected: _ctx.$route.path === '/'
            }, null, 8, ["click", "selected"]),
            _createVNode(_component_ProfileButton, {
              click: _ctx.onProfile,
              selected: _ctx.profileActive
            }, null, 8, ["click", "selected"]),
            _createVNode(_component_LogoutButton, { click: _ctx.onLogout }, null, 8, ["click"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.token != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createVNode(_component_router_view)
          ])
        ]))
      : (_ctx.token == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_login_view)
          ]))
        : _createCommentVNode("", true)
  ], 64))
}